import React from 'react';
import PropTypes from 'prop-types';
import { Collapse, Icon } from 'antd';
import CommunitiesSearch from '../../../Communities/CommunitiesSearch';
import { Translate } from '@above-the-treeline/localization';
import ListsTitleCouldBeOnSection from './ListsTitleCouldBeOnSection';
import NoMatchesFoundMessage from '../../../UI/NoMatchesFoundMessage';

const Panel = Collapse.Panel;

CommunitiesOfListsToAddTitleTo.propTypes = {
	listCommunities: PropTypes.array,
	isLoading: PropTypes.bool,
	listsByCommunityId: PropTypes.object,
	skus: PropTypes.array,
};

function CommunitiesOfListsToAddTitleTo({
	listCommunities,
	isLoading,
	listsByCommunityId,
	skus,
}) {
	const [filteredCommunities, setFilteredCommunities] = React.useState(null);
	const communities = filteredCommunities || listCommunities;

	const filterCommunities = value => {
		const filteredCommunities = listCommunities.filter(comm =>
			comm.name.toLowerCase().includes(value.toLowerCase()),
		);
		setFilteredCommunities(filteredCommunities);
	};

	const getCommunityHeader = name => {
		return (
			<>
				<span className="bold">
					<Translate id="community" />
				</span>
				{name ? <span> {name}</span> : null}
			</>
		);
	};

	const renderCommunities = (lists, idx, community) => {
		return (
			<Panel
				header={getCommunityHeader(community.name || null)}
				key={idx}>
				<ListsTitleCouldBeOnSection
					lists={lists}
					community={community}
					isLoading={isLoading}
					skus={skus}
				/>
			</Panel>
		);
	};

	const renderCommunitiesContainer = () => {
		return !communities.length ? (
			<NoMatchesFoundMessage />
		) : (
			<Collapse
				accordion
				defaultActiveKey={['0']}
				expandIcon={({ isActive }) => (
					<Icon type="caret-right" rotate={isActive ? 90 : 0} />
				)}>
				{listsByCommunityId &&
					communities.map((community, idx) =>
						renderCommunities(
							listsByCommunityId[community.id],
							idx,
							community,
						),
					)}
			</Collapse>
		);
	};

	return (
		<>
			<CommunitiesSearch
				onChange={filterCommunities}
				communitiesCount={listCommunities.length}
			/>
			{renderCommunitiesContainer()}
		</>
	);
}

export default CommunitiesOfListsToAddTitleTo;
